export enum DurationEvent {
  All = "",
  Day = "DAY",
  Morning = "MORNING",
  Afternoon = "AFTERNOON",
  Evening = "EVENING",
}
